import AttributeDetailRenderer from "./AttributeDetailRenderer.js";
import Formatters from '../../attribute/formatter/Formatters.js';
import I18nResolvers from '../../attribute/i18nResolver/I18nResolvers.js';

/**
 * Renders boolean attribute details.
 */
export default class BooleanAttributeDetailRenderer extends AttributeDetailRenderer {
  formatAndI18nResolveValue(value) {
    const shouldOverrideValue = this.detail.formatter?.overrideValue !== false;
    if (shouldOverrideValue) {
      return Formatters.format(value, this.detail.formatter);
    }
    return I18nResolvers.resolve(value, this.detail);
  }
}